import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Tabs, TabList, Tab, TabPanels, TabPanel, List, UnorderedList, ListItem, FormControl, FormLabel, Input, InputLeftAddon, InputGroup } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import admin from '../../../api/admin';
import { IAsset } from '../../../models/asset';
import { GetAssetResponse } from '../../../models/admin-api/dto';
import ProgressLoader from '../../progressLoader';
import AssetAttachmentList from '../assetAttachmentList';
import { IMeta } from '../../../models/metaData';


const ExternalAssetViewer = props => {

    const [isLoading, setIsLoading] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState<IAsset>();
    const [selectedMeta, setSelectedMeta] = useState<IMeta[]>([]);

    let { id } = useParams();


    useEffect(() => {

        let assetid = props.assetId || id;

        if (assetid) {

            if (assetid !== undefined) {
                setIsLoading(true);

                admin.Assets.GetAssetViewer(assetid, props.sharedProjectId, props.password).then(
                    (res: GetAssetResponse) => {
                        if (res?.result!) {
                            setSelectedAsset(res.result);
                            if (res.result.meta) {
                                setSelectedMeta(JSON.parse(res.result.meta).items);
                            }
                            setIsLoading(false);
                        }
                        else {
                            setIsLoading(false)
                        }
                    },
                    (error) => {
                        alert('Error Retrieving asset!' + error);
                        setIsLoading(false);
                    }
                );
            }
            else {
                alert("Missing Asset ID!")
            }
        }
    }
        , [props.assetId, id]);




    return (
        <>
            {isLoading ? (<ProgressLoader />) :

                (<>

                    {selectedAsset ? (

                        <Tabs isFitted variant='enclosed'>
                            <TabList mb='1em'>
                                <Tab>Asset</Tab>
                                <Tab>Additional Details</Tab>
                                <Tab>Attachments</Tab>
                            </TabList>
                            <TabPanels>
                                <TabPanel>

                                    <>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Name</InputLeftAddon><Input value={selectedAsset.name} />
                                        </InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Type</InputLeftAddon>
                                            <Input value={selectedAsset.type} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Manufacturer</InputLeftAddon>
                                            <Input value={selectedAsset.manufacturer} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Model</InputLeftAddon>
                                            <Input value={selectedAsset.model} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Serial No</InputLeftAddon>
                                            <Input value={selectedAsset.serialNo} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Location</InputLeftAddon>
                                            <Input value={selectedAsset.location} /></InputGroup>
                                        <InputGroup padding={1}>
                                            <InputLeftAddon>Floor</InputLeftAddon>
                                            <Input value={selectedAsset.floor} /></InputGroup>
                                    </>

                                </TabPanel>
                                <TabPanel>
                                    <FormControl>
                                        {selectedMeta.map((item: IMeta) => (


                                            <>
                                                <InputGroup padding={1}>
                                                    <InputLeftAddon>{item.Key}</InputLeftAddon>
                                                    <Input value={item.Value} /></InputGroup>
                                            </>


                                        ))}
                                    </FormControl>
                                </TabPanel>
                                <TabPanel>

                                    <AssetAttachmentList assetId={props.assetId} />

                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    ) : (<b>No Asset Information Found!</b>)}

                </>)
            }

        </>
    )
}


ExternalAssetViewer.propTypes = {
    assetId: PropTypes.number,
    password: PropTypes.string,
    sharedProjectId: PropTypes.string

}



export default observer(ExternalAssetViewer)